module.exports = __webpack_public_path__ + "static/media/daning.5f8eac22.png";